import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Typography } from '@mui/material';
import PaymentsIcon from '@mui/icons-material/Payments';

const ZonePriceListModal = ({ open, setOpen, isTitle, isDeliveryRate }) => {
    const toggle = () => setOpen(prevState => !prevState);

    return (
        <Modal
            isOpen={open}
            toggle={toggle}
            className="theme-light ltr-support credit-memo-modal-form-ani"
            centered
            style={{ maxWidth: '600px' }}
        >
            <div className="modal__header border-bottom-0 pb-0">
                <button
                    className="lnr lnr-cross modal__close-btn"
                    aria-label="modal__close-btn"
                    type="button"
                    onClick={toggle}
                />
                <div className="d-flex align-items-center mb-1">
                    <PaymentsIcon className="text-primary me-2" style={{ fontSize: '1.5rem' }} />
                    <h5 className="modal__title text-uppercase fw-bold m-0" style={{ color: "#21B368", fontSize: '1rem' }}>
                        {isTitle || "Zone Price List"}
                    </h5>
                </div>
            </div>
            <ModalBody className="p-3">
                <Paper elevation={0} className="border rounded overflow-hidden">
                    <Table size="small">
                        <TableHead>
                            <TableRow style={{ background: "#f8f9fa" }}>
                                <TableCell className="fw-bold py-2" style={{ fontSize: '0.85rem' }}>Zone Code</TableCell>
                                <TableCell className="fw-bold py-2" style={{ fontSize: '0.85rem' }}>Zone Name</TableCell>
                                <TableCell className="fw-bold py-2 text-end" style={{ fontSize: '0.85rem' }}>Rate (AED)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isDeliveryRate && isDeliveryRate.length > 0 ? (
                                isDeliveryRate.map((row, idx) => (
                                    <TableRow key={idx} hover>
                                        <TableCell className="py-2" style={{ fontSize: '0.85rem' }}>{row.areaCode}</TableCell>
                                        <TableCell className="py-2" style={{ fontSize: '0.85rem' }}>{row.areaName}</TableCell>
                                        <TableCell className="py-2 text-end fw-bold text-success" style={{ fontSize: '0.85rem' }}>{Number(row.rate).toFixed(2)}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={3} className="text-center py-4 text-muted">No data available</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Paper>
                <div className="mt-3 text-end">
                    <Typography variant="caption" className="text-muted">Prices are exclusive of VAT where applicable.</Typography>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ZonePriceListModal;